import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';


const dominios = {
    state: {
        dominios: {},
        dominiosOrder: {},
    },
    getters: {
        getDominios: state => state.dominios,
        getDominiosOrder: state => state.dominiosOrder,
    },
    actions: {
        requestDominios: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/Dominios/dominios').then(result => {
                    if (result.data.status == 0) {
                        commit('setDominios', result.data.datos);
                    } else {
                        commit('setError', result.data.status);
                    }
                }).catch(error => {
                    reject(false);
                });

            });
        },
        requestProgramasInformaticos: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/Dominios/ProgramasInformaticos').then(result => {
                    if (result.data.status == 0) {
                        let data = {
                            programasInformaticos: result.data.datos
                        }
                        commit('setDominios', data);
                    } else {
                        commit('setError', result.data.status);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestTitulaciones: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/Dominios/titulaciones').then(result => {
                    if (result.data.status == 0) {
                        commit('setTitulaciones', result.data.datos);
                    } else {
                        commit('setError', result.data.status);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestPromociones: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/Dominios/promociones').then(result => {
                    if (result.data.status == 0) {
                        commit('setPromociones', result.data.datos);
                    } else {
                        commit('setError', result.data.status);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestKeywords: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/Dominios/keywords').then(result => {
                    if (result.data.status == 0) {
                        let data = {
                            keywords: result.data.datos
                        }
                        commit('setDominios', data);
                    } else {
                        commit('setError', result.data.status);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestDominiosRegistroEmpresa: ({ commit }) => {

            let needed = {
                'keywords': null,
                'sectoresActividad': null,
                'paises': null,
                'provincias': null,
                'tiposEmpresa': null
            };

            let count = 0;
            let max = Object.keys(needed).length;

            return new Promise((resolve, reject) => {

                for (let i in needed) {
                    axios.get('/api/Dominios/' + i).then(result => {
                        if (result.data.status == 0) {
                            needed[i] = result.data.datos;
                            count++;
                            if(count == max){
                                commit('setRegistroDomains',needed);
                            }

                        } else {
                            commit('setError', result.data.status);
                        }
                    }).catch(error => {
                        reject(false);
                    });
                }
            });
        }
    },
    mutations: {
        setDominios(state, dominios) {
            for (let i in dominios) {
                state.dominios[i] = dominios[i]
                state.dominiosOrder[i] = Object.entries(dominios[i]).sort(function (p1, p2) {
                    return (p1[1].toLowerCase() < p2[1].toLowerCase()) ? -1 : 1;
                });
            }

        },
        setTitulaciones(state, dominios) {
            state.dominios.titulaciones = dominios;
            state.dominiosOrder.titulaciones = dominios;
        },
        setPromociones(state, dominios) {
            state.dominios.promociones = dominios;
            state.dominiosOrder.promociones = dominios;
        },
        setRegistroDomains(state,data) {
            for(let i in data){

                state.dominios[i] = data[i];
                state.dominiosOrder[i] = Object.entries(data[i]).sort(function (p1, p2) {
                    return (p1[1].toLowerCase() < p2[1].toLowerCase()) ? -1 : 1;
                });
            }
        }
    }
}

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominiosModule.js